import React, { createContext, useContext, useEffect, useState } from "react";
import { auth, db } from "../firebase"; // Importa la configuración de Firebase y Firestore
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { normalizeRole } from "../utils/roles";



// Crear el contexto de autenticación
const AuthContext = createContext();

// Hook personalizado para usar el contexto de autenticación
export const useAuth = () => {
  return useContext(AuthContext);
};

// Proveedor de autenticación
export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null); // Estado para el usuario actual
  const [loading, setLoading] = useState(true); // Estado para manejar la carga

  useEffect(() => {
    // Suscribirse a los cambios en el estado de autenticación
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // Si el usuario está autenticado, obtener su rol desde Firestore
        const userDoc = await getDoc(doc(db, "users", user.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          // Agregar el campo "role" al objeto currentUser
          setCurrentUser({ ...user, role: normalizeRole(userData.role) });
        } else {
          // Si no existe el documento en Firestore, establecer el usuario sin el campo "role"
          setCurrentUser(user);
        }
      } else {
        // Si no hay usuario autenticado, establecer currentUser como null
        setCurrentUser(null);
      }
      setLoading(false); // Finalizar la carga
    });

    // Limpiar la suscripción al desmontar el componente
    return unsubscribe;
  }, []);

  // Valor proporcionado por el contexto
  const value = {
    currentUser,
    loading,
  };

  return (
    <AuthContext.Provider value={value}>
      {/* Renderizar los hijos solo cuando no esté cargando */}
      {!loading && children}
    </AuthContext.Provider>
  );
};
